import { FormEvent, ReactNode, useCallback } from "react";
import { toast } from "sonner";
import { GENERIC_MUTATION_ERROR_MESSAGE } from "@/lib/error-utils";
import { useOnlineStatus } from "@/hooks/useOnlineStatus";
import { cn } from "@/lib/utils";

function isOfflineAllowed(target: EventTarget | null) {
  if (!(target instanceof HTMLElement)) return false;
  return Boolean(target.closest("[data-allow-offline]"));
}

export function OfflineEditGuard({ children }: { children: ReactNode }) {
  const { isOffline } = useOnlineStatus();

  const preventOfflineSubmit = useCallback(
    (event: FormEvent<HTMLDivElement>) => {
      if (!isOffline || isOfflineAllowed(event.target)) return;
      event.preventDefault();
      event.stopPropagation();
      toast.error(GENERIC_MUTATION_ERROR_MESSAGE);
    },
    [isOffline],
  );

  return (
    <div
      className={cn(
        "contents",
        isOffline &&
          "[&_button[data-offline-edit]]:pointer-events-none [&_button[data-offline-edit]]:opacity-50 [&_[role=menuitem][data-offline-edit]]:pointer-events-none [&_[role=menuitem][data-offline-edit]]:opacity-50",
      )}
      data-offline={isOffline ? "" : undefined}
      onSubmitCapture={preventOfflineSubmit}
    >
      {children}
    </div>
  );
}
